import { colors } from '@highlight-run/ui/colors'
import {
	IconSolidFire,
	IconSolidHashtag,
	Tabs,
} from '@highlight-run/ui/components'
import {
	RightPlayerTab,
	usePlayerUIContext,
} from '@pages/Player/context/PlayerUIContext'

import EventStreamV2 from '@/pages/Player/components/EventStreamV2/EventStreamV2'
import MetadataPanel from '@/pages/Player/MetadataPanel/MetadataPanel'

const RightPanelTabs = () => {
	const { selectedRightPanelTab, setSelectedRightPanelTab } =
		usePlayerUIContext()

	return (
		<Tabs<RightPlayerTab>
			selectedId={selectedRightPanelTab}
			onChange={setSelectedRightPanelTab}
		>
			<Tabs.List px="8" gap="8">
				<Tabs.Tab
					id={RightPlayerTab.Events}
					icon={
						<IconSolidFire
							color={
								selectedRightPanelTab === RightPlayerTab.Events
									? colors.p9
									: undefined
							}
						/>
					}
				>
					Events
				</Tabs.Tab>
				<Tabs.Tab
					id={RightPlayerTab.Metadata}
					icon={
						<IconSolidHashtag
							color={
								selectedRightPanelTab ===
								RightPlayerTab.Metadata
									? colors.p9
									: undefined
							}
						/>
					}
				>
					Metadata
				</Tabs.Tab>
			</Tabs.List>
			<Tabs.Panel id={RightPlayerTab.Events}>
				<EventStreamV2 />
			</Tabs.Panel>
			<Tabs.Panel id={RightPlayerTab.Metadata}>
				<MetadataPanel />
			</Tabs.Panel>
		</Tabs>
	)
}

export default RightPanelTabs
